import { useMutation, useQuery } from "@tanstack/react-query";
import { PayrollAPI } from "../api";

export const useGetAllAllowanceTypesPaginated = () => {
  return useMutation({
    mutationFn: ({
      page,
      pageSize,
      filterField1 = null,
      filterValue1 = null,
      filterField2 = null,
      filterValue2 = null,
    }) => {
      const obj = {
        page,
        pageSize,
      };
      if (filterField1 && filterValue1) {
        obj.filterField1 = filterField1;
        obj.filterValue1 = filterValue1;
      }

      if (filterField2 && filterValue2) {
        obj.filterField2 = filterField2;
        obj.filterValue2 = filterValue2;
      }
      return PayrollAPI.getAllAllowanceTypesPaginated(obj);
    },
    onError: (error) => {
      console.error(
        "Get All Allowance Types Failed: ",
        error.response || error
      );
    },
  });
};

export const _useGetAllAllowanceTypesPaginated = ({
  page,
  pageSize,
  filterField1 = null,
  filterValue1 = null,
  filterField2 = null,
  filterValue2 = null,
}) => {
  return useQuery({
    queryKey: [
      "allowance-types",
      page,
      pageSize,
      filterField1,
      filterValue1,
      filterField2,
      filterValue2,
    ],
    queryFn: () => {
      const obj = { page, pageSize };

      if (filterField1 && filterValue1) {
        obj.filterField1 = filterField1;
        obj.filterValue1 = filterValue1;
      }

      if (filterField2 && filterValue2) {
        obj.filterField2 = filterField2;
        obj.filterValue2 = filterValue2;
      }

      return PayrollAPI.getAllAllowanceTypesPaginated(obj);
    },
    onError: (error) => {
      console.error(
        "Get All Allowance Types Failed:",
        error?.response || error
      );
    },
  });
};

export const useGetAllDeductionTypesPaginated = () => {
  return useMutation({
    mutationFn: ({
      page,
      pageSize,
      filterField1 = null,
      filterValue1 = null,
      filterField2 = null,
      filterValue2 = null,
    }) => {
      const obj = {
        page,
        pageSize,
      };
      if (filterField1 && filterValue1) {
        obj.filterField1 = filterField1;
        obj.filterValue1 = filterValue1;
      }

      if (filterField2 && filterValue2) {
        obj.filterField2 = filterField2;
        obj.filterValue2 = filterValue2;
      }
      return PayrollAPI.getAllDeductionTypesPaginated(obj);
    },
    onError: (error) => {
      console.error(
        "Get All Deduction Types Failed: ",
        error.response || error
      );
    },
  });
};

export const _useGetAllDeductionTypesPaginated = ({
  page,
  pageSize,
  filterField1 = null,
  filterValue1 = null,
  filterField2 = null,
  filterValue2 = null,
}) => {
  return useQuery({
    queryKey: [
      "deduction-types",
      page,
      pageSize,
      filterField1,
      filterValue1,
      filterField2,
      filterValue2,
    ],
    queryFn: () => {
      const obj = { page, pageSize };

      if (filterField1 && filterValue1) {
        obj.filterField1 = filterField1;
        obj.filterValue1 = filterValue1;
      }

      if (filterField2 && filterValue2) {
        obj.filterField2 = filterField2;
        obj.filterValue2 = filterValue2;
      }

      return PayrollAPI.getAllDeductionTypesPaginated(obj);
    },
    onError: (error) => {
      console.error(
        "Get All Deduction Types Failed:",
        error?.response || error
      );
    },
  });
};

export const useCreateNewAllowanceType = () => {
  return useMutation({
    mutationFn: ({ code, description, deminimis }) =>
      PayrollAPI.createAllowanceType({ code, description, deminimis }),
    onError: (error) => {
      console.error("Create Allowance Type Failed: ", error.response || error);
    },
  });
};
export const useCreateNewDeductionType = () => {
  return useMutation({
    mutationFn: ({ code, description, statutory }) =>
      PayrollAPI.createDeductionType({ code, description, statutory }),
    onError: (error) => {
      console.error("Create Deduction Type Failed: ", error.response || error);
    },
  });
};

export const useGetAllowanceTypeById = () => {
  return useMutation({
    mutationFn: (id) => PayrollAPI.getAllowanceTypeById(id),
  });
};

export const useGetDeductionTypeById = () => {
  return useMutation({
    mutationFn: (id) => PayrollAPI.getDeductionTypeById(id),
  });
};

export const useUpdateAllowanceType = () => {
  return useMutation({
    mutationFn: ({ id, code, description, deminimis }) => {
      return PayrollAPI.updateAllowanceType({
        id,
        code,
        description,
        deminimis,
      });
    },
  });
};
export const useUpdateDeductionType = () => {
  return useMutation({
    mutationFn: ({ id, code, description, statutory }) => {
      return PayrollAPI.updateDeductionType({
        id,
        code,
        description,
        statutory,
      });
    },
  });
};
export const useGetAllEmployeeSalaryRecordsPaginated = () => {
  return useMutation({
    mutationFn: ({
      page,
      pageSize,
      filterField1 = null,
      filterValue1 = null,
      filterField2 = null,
      filterValue2 = null,
    }) => {
      const obj = {
        page,
        pageSize,
      };
      if (filterField1 && filterValue1) {
        obj.filterField1 = filterField1;
        obj.filterValue1 = filterValue1;
      }

      if (filterField2 && filterValue2) {
        obj.filterField2 = filterField2;
        obj.filterValue2 = filterValue2;
      }
      return PayrollAPI.getAllEmployeeSalaryRecordsPaginated(obj);
    },
    onError: (error) => {
      console.error(
        "Get All Employee Salary Records Failed: ",
        error.response || error
      );
    },
  });
};

export const useCreateEmployeeSalaryRecord = () => {
  return useMutation({
    mutationFn: (payload) => PayrollAPI.createEmployeeSalaryRecord(payload),
    onError: (error) => {
      console.error("Create Employee Salary Failed: ", error.response || error);
    },
  });
};

export const useUpdateEmployeeSalaryRecord = () => {
  return useMutation({
    mutationFn: ({ id, payload }) =>
      PayrollAPI.updateEmployeeSalaryRecord({ id, payload }),
    onError: (error) => {
      console.error("Update Employee Salary Failed: ", error.response || error);
    },
  });
};

export const _useGetEmployeeSalaryRecordById = (id) => {
  return useQuery({
    queryKey: ["get-employee-salary-record-by-id", id],
    queryFn: () => PayrollAPI.getSalaryRecordById(id),
    enabled: !!id,
    onError: (error) => {
      console.error(
        "Get Salary Record By ID Failed: ",
        error.response || error
      );
    },
  });
};

export const useDeleteAllowanceType = () => {
  return useMutation({
    mutationFn: (id) => PayrollAPI.deleteAllowanceTypeById(id),
    onError: (error) => {
      console.error("Delete Allowance Type Failed: ", error.response || error);
    },
  });
};

export const useDeleteDeductionType = () => {
  return useMutation({
    mutationFn: (id) => PayrollAPI.deleteDeductionTypeById(id),
    onError: (error) => {
      console.error("Delete Deduction Type Failed: ", error.response || error);
    },
  });
};
